import { Injectable } from '@angular/core';
import { UserModel } from '@common/models/User.model';
import { currentUserSubject } from '@common/services/user.service';

@Injectable({
    providedIn: 'root'
})
export class DisplayDiscrepanciesService {
    private readonly STORAGE_KEY_PREFIX = 'displayDiscrepancies';
    private currentUser: UserModel | null = null;

    constructor() {
        currentUserSubject.subscribe((user) => {
            this.currentUser = user;
        });
    }

    private getUserSpecificStorageKey(): string {
        if (!this.currentUser?.id) {
            return `${this.STORAGE_KEY_PREFIX}_default`;
        }
        return `${this.STORAGE_KEY_PREFIX}_user_${this.currentUser.id}`;
    }

    get displayDiscrepancies(): boolean {
        const storageKey = this.getUserSpecificStorageKey();
        const storedValue = localStorage.getItem(storageKey);
        return storedValue ? JSON.parse(storedValue) : false;
    }

    set displayDiscrepancies(value: boolean) {
        const storageKey = this.getUserSpecificStorageKey();
        localStorage.setItem(storageKey, JSON.stringify(value));
    }

    toggle(): void {
        this.displayDiscrepancies = !this.displayDiscrepancies;
    }
}
